import { Stack, Typography } from "@mui/material";
import UserAvatar from "@entrilia/shared/components/UserAvatar";

interface Props {
  userName: string;
  avatarImage?: string;
  email?: string;
}

const UserInfoMenuItem = ({ userName, avatarImage, email }: Props) => (
  <Stack spacing={0.5} direction="row" sx={{ m: 2 }}>
    <UserAvatar size="large" userName={userName} avatarImage={avatarImage} />
    <Stack>
      <Typography variant="subtitle2" color="primary">
        {userName}
      </Typography>
      {email && <Typography color="secondary">{email}</Typography>}
    </Stack>
  </Stack>
);

export default UserInfoMenuItem;
